import { memo, useMemo } from 'react';
import classNames from 'classnames';
import stripHtml from '../../utils/wordlist/stripHtml';
import { useInView } from 'react-intersection-observer';

type Word = {
  id: string;
  untranslated: string;
  translated: string;
};

type WordListRowProps = {
  word: Word;
  isFavorite?: boolean;
  isActive?: boolean;
  switched?: boolean;
  onFavorite: () => void;
  onClick: () => void;
};

function WordlistRow({ word, isActive, isFavorite, switched, onFavorite, onClick }: WordListRowProps) {
  const untranslated = useMemo(() => ({ __html: stripHtml(word.untranslated) }), [word]);
  const translated = useMemo(() => ({ __html: stripHtml(word.translated) }), [word]);

  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: '200px 0px',
  });

  return (
    <tr
      ref={ref}
      className={classNames('wordlist__table-row', {
        'wordlist__table-row--active': isActive,
      })}
      onClick={onClick}
    >
      {inView ? (
        <>
          <td
            className="wordlist__table-cell wordlist__table-cell--bold"
            dangerouslySetInnerHTML={!switched ? untranslated : translated}
          />
          <td className="wordlist__table-cell" dangerouslySetInnerHTML={!switched ? translated : untranslated} />
          <td className="wordlist__table-cell wordlist__table-cell--action">
            <button
              className="wordlist__btn-favorite"
              type="button"
              onClick={e => {
                e.stopPropagation();
                onFavorite();
              }}
            >
              <svg className="icon" role="img">
                <use href={`#icon-favorite${isFavorite ? '-full' : ''}`} />
              </svg>
            </button>
          </td>
        </>
      ) : (
        <td colSpan={3} />
      )}
    </tr>
  );
}

export default memo(WordlistRow);
